import React from 'react';

import styled from 'styled-components';

import { AccentBadge } from './accent-badge';
import { IBadgeProps } from './types';

const Badge = styled(AccentBadge)`
  background-color: transparent;
  padding: 0;
  margin-block-start: 4px;
  margin-block-end: 0;
  margin-inline: 0;
`;

export const LoginRequiredBadge: React.FC<IBadgeProps> = ({ formatMessage }) => (
  <Badge data-testid="login-required-badge">{formatMessage({ id: 'signUpToRedeem' })}</Badge>
);
